import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { Paper } from '@mui/material';
import { StyledTableContainer, StyledTable } from 'components/common/Styles';
import FinancialProductRulesEditDetailsServicesTableHead from './FinancialProductRulesEditDetailsServicesTableHead';
import FinancialProductRulesEditDetailsServicesTableBody from './FinancialProductRulesEditDetailsServicesTableBody';

const FinancialProductRulesEditDetailsServicesTable = ({
  canWrite,
  serviceList,
  financialProductRuleServiceTypeList,
  financialProductRuleServiceDetailCalcTypeList,
  financialProductRuleSupplierList,
  isSaved,
  onAdd,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleServiceValidation,
  onLoadFinancialProductRuleSupplierList
}) => {
  const [t] = useTranslation();

  return (
    <>
      <StyledTableContainer component={Paper}>
        <StyledTable>
          <FinancialProductRulesEditDetailsServicesTableHead canWrite={canWrite} isSaved={isSaved} onAdd={onAdd} />
          {isSaved && (
            <FinancialProductRulesEditDetailsServicesTableBody
              canWrite={canWrite}
              serviceList={serviceList}
              financialProductRuleServiceTypeList={financialProductRuleServiceTypeList}
              financialProductRuleServiceDetailCalcTypeList={financialProductRuleServiceDetailCalcTypeList}
              financialProductRuleSupplierList={financialProductRuleSupplierList}
              onCloseEdit={onCloseEdit}
              onDelete={onDelete}
              onSave={onSave}
              financialProductRuleServiceValidation={financialProductRuleServiceValidation}
              onLoadFinancialProductRuleSupplierList={onLoadFinancialProductRuleSupplierList}
            />
          )}
        </StyledTable>
      </StyledTableContainer>
      {!isSaved && <Placeholder message={t('FinancialProduct.Details.Rules.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isSaved && serviceList?.length === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductRulesEditDetailsServicesTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  serviceList: PropTypes.object.isRequired,
  financialProductRuleServiceTypeList: PropTypes.array.isRequired,
  financialProductRuleServiceDetailCalcTypeList: PropTypes.array.isRequired,
  financialProductRuleSupplierList: PropTypes.array.isRequired,
  isSaved: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleServiceValidation: PropTypes.object.isRequired,
  onLoadFinancialProductRuleSupplierList: PropTypes.func.isRequired
};

export default FinancialProductRulesEditDetailsServicesTable;
